import React from 'react';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { StateType } from '@central-products/interface-session-service';
import { feature as myaccountFlowFeature } from '@central-products/myaccount-flow';
import { getValueForDevice, getValueFromContent, openLink, isNative } from '../../utils';
import { HEADER_TYPE_CHANGED } from '../../constants';
import { getMyAccountViewParam, openMyAccountPage, waitForSession, removeMyAccountViewParam } from './utils';
export { MY_ACCOUNT_VIEW_QUERY_PARAM } from './utils';

let headerChangedSubscribeId = null;

const openAccountPageIfNeeded = async (params) => {
  if (typeof window === 'undefined') {
    return;
  }

  const viewUrlParam = getMyAccountViewParam(window.location.search);

  if (viewUrlParam) {
    await waitForSession();
    openMyAccountPage(viewUrlParam, params);
    const url = removeMyAccountViewParam(window.location.search, window.location.toString());
    window.history.pushState(null, '', url);
  }
};

export const myAccountPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params, content, addHeaderRenderers }) {
    const promotionsUrl = getValueFromContent(params.promotionsPageUrl, content);
    const helpPageUrl = getValueFromContent(params.helpPageUrl, content);
    const openFeedbackTopic = getValueFromContent(params.openFeedbackTopic, content);
    const neverOpen = params.neverOpenOnNative && isNative();

    addBootstrapperFeature(myaccountFlowFeature, {
      provideRenderers: addHeaderRenderers,
      promotionsUrl,
      helpPageUrl,
      openFeedbackTopic,
      openLink,
      neverOpen,
    });
  },
  beforeRender({ header, content, params, headerRenderers }) {
    const myAccountButtonConfig = {
      type: '@myaccount/myaccount-button',
      data: {
        id: 'hrs-action__myaccount-button',
      },
      children: [],
    };

    const myAccountModalsConfig = {
      type: '@myaccount/modals',
      data: {
        id: 'pi-header__myaccount-modals',
        urls: {
          withdraw: getValueForDevice(getValueFromContent(params.withdrawUrl, content)),
          reversalWithdraw: getValueForDevice(getValueFromContent(params.reversalWithdrawUrl, content)),
          gamblingControls: getValueForDevice(getValueFromContent(params.gamblingControlsUrl, content)),
          pokerBalanceTransfer: getValueForDevice(getValueFromContent(params.pokerBalanceTransferUrl, content)),
        },
      },
      children: [],
    };

    header.actions.children.splice(1, 0, myAccountButtonConfig);
    header.actions.children.push(myAccountModalsConfig);

    headerRenderers.push({
      type: '@myaccount/myaccount-button',
      render: () => <div key="cp-myacc-button" id="cp-ma-wrapper" />,
    });

    openAccountPageIfNeeded(params);
  },
  async postBootstrap({ bootstrapperFeatures }) {
    const { state: sessionServiceState } = await bootstrapperFeatures['session-service'].getState();

    if (sessionServiceState === StateType.SESSION_EXISTS) {
      bootstrapperFeatures['my-account'].start();
    }

    bootstrapperFeatures['session-service'].onStateChanged(({ state }) => {
      if (state === StateType.SESSION_EXISTS) {
        bootstrapperFeatures['my-account'].start();
        if (!headerChangedSubscribeId) {
          headerChangedSubscribeId = subscribe(HEADER_TYPE_CHANGED, () => {
            publish('wh.common.command.ui.myaccount.cancel');
            publish('wh.common.command.ui.myaccount.start');
          });
        }
      } else {
        unsubscribe(headerChangedSubscribeId);
        headerChangedSubscribeId = null;
      }
    });
  },
};
